import { DatabaseFieldType } from '@databases/types/database';
import { type ValueChange } from '@databases/utils/database/changesets';
import { type Op } from 'quill-delta';

import { type ADFDocument } from '@canvas/adf';

import { type TextLikeFieldType } from '../types.ts';

export const createTextDeltaChange = (
  type: TextLikeFieldType,
  delta: Op[]
): ValueChange =>
  type === DatabaseFieldType.AI_SUMMARY
    ? { type: DatabaseFieldType.AI_SUMMARY, delta }
    : { type: DatabaseFieldType.TEXT, delta };

export const createRichTextChange = (
  type: TextLikeFieldType,
  adf: ADFDocument
): ValueChange =>
  type === DatabaseFieldType.AI_SUMMARY
    ? { type: DatabaseFieldType.AI_SUMMARY, adf }
    : { type: DatabaseFieldType.TEXT, adf };
